module.exports = __webpack_public_path__ + "static/media/sonalika.1f66ddc0.png";